const share = () => {
  const btnShare = document.querySelector('#btn-share');

	if (btnShare) {
		btnShare.classList.add('a2a_dd');

		const script = document.createElement('script');
		script.src = 'https://static.addtoany.com/menu/page.js';
		script.id = 'addtoany';
		document.body.appendChild(script);
	}
};

export default share;